import { render, staticRenderFns } from "./ModalCompetencia.vue?vue&type=template&id=c7d0a780"
import script from "./ModalCompetencia.vue?vue&type=script&lang=js"
export * from "./ModalCompetencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports